import React, { useContext, useState } from "react";
import { FluentButton } from "../../../../../components/FluentUI/Fluent-Button";
import TaskCreationPopup from "../../task-creation-popup/task-creation-popup";
import TaskCreateDocumentModal from "../../task-create-document-modal";
import { LoginContext } from "../../../../../services/api/authentication-api";
import PropTypes from "prop-types";
import { FluentTabList } from "../../../../../components/FluentUI/Fluent-TabList";
import FluentSpinner from "../../../../../components/FluentUI/Fluent-Spinner";
import { FluentBadge } from "../../../../../components/FluentUI/Fluent-Badge";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import { useHistory } from 'react-router-dom';

export const TaskMainHeader = ({ data, type, setType, canCreate, labels }) => {
  // const { currentUser, userID } = useContext(LoginContext);
  // const [model, setModel] = useState({
  //   showTaskCreationPopup: false,
  //   showDCTaskModal: false,
  // });
  let history = useHistory();
  const AccordionItems = () => {
    return [
      {
        Label: (
          <div className="task-list-tab-item">
            Active
            {type === "Active" &&
              (data?.isLoading ? (
                <FluentSpinner appearance="primary"></FluentSpinner>
              ) : (
                <FluentBadge
                  text={`${data?.data?.length ?? ''} ${labels?.TaskPlural ?? 'Tasks'}`}
                  appearance="filled"
                ></FluentBadge>
              ))}
          </div>
        ),
        Id: "Active",
      },
      {
        Label: (
          <div className="task-list-tab-item">
            Completed
            {type === "Completed" &&
              (data?.isLoading ? (
                <FluentSpinner appearance="primary"></FluentSpinner>
              ) : (
                <FluentBadge
                  text={`${data?.data?.length ?? ''} ${labels?.TaskPlural ?? 'Tasks'}`}
                  appearance="filled"
                ></FluentBadge>
              ))}
          </div>
        ),
        Id: "Completed",
      },
      {
        Label: (
          <div className="task-list-tab-item">
            Archived
            {type === "Archived" &&
              (data?.isLoading ? (
                <FluentSpinner appearance="primary"></FluentSpinner>
              ) : (
                <FluentBadge
                  text={`${data?.data?.length ?? ''} ${labels?.TaskPlural ?? 'Tasks'}`}
                  appearance="filled"
                ></FluentBadge>
              ))}
          </div>
        ),
        Id: "Archived",
      },
    ];
  };

  return (
    <div className="task-tab-create">
      <FluentTabList
        tabList={AccordionItems()}
        vertical={false}
        tabClick={(type) => {
          setType(type);
        }}
        currentTab={type}
      />
      <FluentButton
        icon={<FluentUiIcon name={"AddRegular"} color={"#fff"} size={18} />}
        appearance="primary"
        onClick={() =>  history.push("/tasks/create/std")}
        text={`Create ${labels?.TaskSingular ?? 'Task'}`}
        disabled={!canCreate}
      />
      {/* {model.showTaskCreationPopup && (
        <TaskCreationPopup
          show={model.showTaskCreationPopup}
          onHide={() => {
            setModel({ ...model, showTaskCreationPopup: false });
          }}
          onShowDCTask={() =>
            setModel({
              ...model,
              showDCTaskModal: true,
              showTaskCreationPopup: false,
            })
          }
          privileges={currentUser.privileges}
          userID={userID}
          isTelerikGrid={true}
        />
      )} */}
      {/* {model.showDCTaskModal && (
        <TaskCreateDocumentModal
          show={model.showDCTaskModal}
          onHide={() => {
            setModel({ ...model, showDCTaskModal: false });
          }}
          dateFormatID={currentUser.department.dateFormatID}
          privileges={currentUser.privileges}
        />
      )} */}
    </div>
  );
};

TaskMainHeader.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  setType: PropTypes.func.isRequired,
  canCreate: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
      ProjectSingular: PropTypes.string,
      ProjectPlural: PropTypes.string,
      ProjectSingularPossessive: PropTypes.string,
      ProjectPluralPossessive: PropTypes.string,
      TaskSingular: PropTypes.string,
      TaskPlural: PropTypes.string,
      TaskSingularPossessive: PropTypes.string,
      TaskPluralPossessive: PropTypes.string,
      FormSingular: PropTypes.string,
      FormPlural: PropTypes.string,
      FormSingularPossessive: PropTypes.string,
      FormPluralPossessive: PropTypes.string,
  }),
};
